import React, { FC } from 'react';
import { StyledCell, Span } from './styles';

interface Props {
  span?: Span;
}

export const Cell: FC<Props> = props => <StyledCell {...props} />;
